import { useEffect } from 'react'

type Callback = (...args: any[]) => void

const createEffect =
  (fn: Callback): Callback =>
  (...args) =>
    useEffect(() => fn(...args), args) // eslint-disable-line react-hooks/exhaustive-deps

export default createEffect
